// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import Vuetify from 'vuetify'
import Vuelidate from 'vuelidate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueYoutube from 'vue-youtube'
import VTooltip from 'v-tooltip'
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import VueAmplitude from 'vue-amplitude'
// create a new Event Bus Instance
import router from './router'
import store from './store'

// import * as appboy from '@braze/web-sdk'
// appboy.initialize(process.env.BRAZE_API_KEY, {baseUrl: process.env.BRAZE_SDK, enableLogging: true})
// Vue.prototype.$braze = appboy

if (process.env.ENVIRONMENT === 'prod') {
  Sentry.init({
    Vue,
    dsn: 'https://60d3db5306c44d7eaa229149ea7df330@o462227.ingest.sentry.io/5679333',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
    environment: process.env.ENVIRONMENT
  })
}
Vue.use(Vuetify, {
  theme: {
    primary: '#0855c4',
    secondary: '#00ADEE',
    info: '#717285',
    light: '#d8d8d8',
    dark: '#ea0c90'
  }
})
Vue.use(Vuelidate)
Vue.use(VueSweetalert2)
Vue.use(VueYoutube)
if (process.env.ENVIRONMENT !== 'dev') {
  Vue.use(VueReCaptcha, { siteKey: process.env.CAPTCHA_KEY })
}
Vue.use(VueAmplitude, {
  apiKey: process.env.AMPLITUDE_KEY,
  config: {
    includeGclid: false,
    includeFbclid: false,
    includeReferrer: false,
    includeUtm: false,
    unsetParamsReferrerOnNewSession: false,
    saveParamsReferrerOncePerSession: false
  }
})

Vue.use(VTooltip)

Vue.config.productionTip = false
axios.defaults.baseURL = process.env.API_URL
axios.defaults.headers.get['Accept'] = 'application/json'
axios.defaults.headers.common['Content-Type'] = 'application/json'

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js